export const defaultLogArgsSerializer = (args) => args
    .map((arg) => {
    try {
        return String(arg);
    }
    catch (err) {
        return '';
    }
})
    .join(' ');
//# sourceMappingURL=const.js.map